import {Collapse} from "bootstrap";

export function hideNavOnClick() {
    var navLinks = document.querySelectorAll('.nav-link'); // Select navbar links
    var navbarCollapse = document.getElementById('navbarText'); // Get the navbar collapse element
    navLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            // Check if navbar is expanded
            if (!navbarCollapse.classList.contains('collapsed')) {
                // Use Bootstrap's method to hide the navbar
                var bsCollapse = new Collapse(navbarCollapse, {
                    toggle: false
                });
                bsCollapse.hide(); // Hide the navbar collapse
            }
        });
    });
}

export function hideNavOnScroll() {
    var navbarCollapse = document.getElementById('navbarText'); // Get the navbar collapse element
    if (!navbarCollapse.classList.contains('collapsed')) {
        // Use Bootstrap's method to hide the navbar
        var bsCollapse = new Collapse(navbarCollapse, {
            toggle: false
        });
        bsCollapse.hide(); // Hide the navbar collapse
    }
}